module.exports = __webpack_public_path__ + "img/card-bg.34b138ef.svg";